import { FormControl, TextField, MenuItem, InputLabel, Select, Autocomplete, Button, Drawer, Snackbar, Alert } from '@mui/material'
import React, { useEffect, useMemo, useState, useRef } from 'react'
import TPCheckbox from "../../TemplateProperties/TPCheckbox";
import { afterReadOptions, authOptions, emailTypeOptions, protocolOptions, readDataOptions } from '../../../constants/constantList';
import _, { debounce } from 'lodash';
import { useTranslation } from 'react-i18next';
import { decryptString, encryptString, stringifyJSONAttributes, stringToBooleanConversion } from '../../../utils/utilFunctions';
import { api } from '../../../redux/api';
import { useDispatch } from 'react-redux';
import CloseIcon from '@mui/icons-material/Close';
import SmartPasswordField from '../../../commonComponents/SmartPasswordField';
import { MoreHorizOutlined } from '@mui/icons-material';
import WorkflowSessionModal from '../../ItemProperties/WorkflowSessionModal';

const Email = ({
  connectionDetails,
  connectionName = "",
  handleBodyContent,
  direction,
  account,
  screen = "",
  disableControl,
  repoPDC,
  useConnection,
  source = "",
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [mailServer, setMailServer] = useState("");
  const [ssl, setSsl] = useState(false);
  const [tls, setTls] = useState(false);
  const [user, setUser] = useState("");
  const [authType, setAuthType] = useState("");
  const [pass, setPass] = useState("");
  const [tenandId, setTenantId] = useState("");
  const [clientId, setClientId] = useState("");
  const [clientSecret, setClientSecret] = useState("");
  const [protocol, setProtocol] = useState("POP3");
  const [mailType, setMailType] = useState("SMTP");
  const [emailType, setEmailType] = useState("");
  const [afterReading, setAfterReading] = useState("");
  const [readData, setReadData] = useState(t(""));
  const [decompression, setDecompression] = useState(false);
  const [showDecompressionDir, setShowDecompressionDir] = useState(false);
  const [decompressionDir, setDecompressionDir] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [valueLabel, setValueLabel] = useState("");
  const [workflowSessionModal, setWorkflowSessionModal] = useState({
    open: false,
    isFirstTime: false,
  });
  

  // Destination
  const [smtpMailServer, setSmtpMailServer] = useState("");
  const [to, setTo] = useState("");
  const [from, setFrom] = useState("");
  const [cc, setCc] = useState("");
  const [bcc, setBcc] = useState("");
  const [subject, setSubject] = useState("");
  const [messageId, setMessageId] = useState("");
  const [sendData, setSendData] = useState("");
  const [bodyContent, setBodyContent] = useState("");
  const [asHtml, setAsHtml] = useState(false);
  const [attachments, setAttachments] = useState("");
  const [authentication, setAuthentication] = useState(false);
  const [compression, setCompression] = useState(false);
  const [compressionList, setCompressionList] = useState([]);
  const [compressionType, setCompressionType] = useState("");
  const [fileNameZip, setFileNameZip] = useState("");
  const [showDestinationPassword, setShowDestinationPassword] = useState(false);
  const [destinationPassword, setDestinationPassword] = useState("");
  const [credentialsJson, setCredentialsJson] = useState("");
  const [refreshToken, setRefreshToken] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [content, setContent] = useState(null);
  const [showAlert, setShowAlert] = useState({
    mssg: "",
    type: "success",
    isOpen: false,
  });
  const shouldEncryptDecryptPassword = String(source || "").toLowerCase() !== "pdc";

  const debouncedContentUpdate = debounce(handleBodyContent, 200);

  const drawerWidth = 400;
  const handleBackdropClick = (event, reason) => {
    if (reason === 'backdropClick') return;
  };

  const onInputChange = (name, value) => {
    if (screen === "GET_DATA") {
      if (name === "MAIL_TYPE" && direction === "IN") {
        let port = "";

        if (value === "POP3") {
          port = ssl ? "995" : "110";
          setContent({
            add: {
              [name]: value,
              PORT: port,
              AFTER_READ_ACTION: null,
              GET_EMAIL_TYPE: null,
            },
          });
        } else if (value === "IMAP") {
          port = ssl ? "993" : "143";
          setContent({
            add: {
              [name]: value,
              PORT: port,
            },
          });
        }
        else {
          setContent({
            add: {
              [name]: value,
              PORT: null,
            },
          });
        }
      } else if (name === "AUTH_TYPE") {
        if (value === "BASIC_AUTH")
          setContent({
            add: {
              [name]: value,
              TENANT_ID: null,
              CLIENT_ID: null,
              CLIENT_SECRET: null,
            },
          });
        else if (value === "OUTLOOK_OAUTH2")
          setContent({ add: { [name]: value, PASSWORD: null } });
        else if (value === "GOOGLE_OAUTH2")
          setContent({
            add: {
              [name]: value,
              REFRESH_TOKEN: null,
              CREDENTIALS_JSON: null,
              PASSWORD: null,
              TENANT_ID: null,
              CLIENT_ID: null,
              CLIENT_SECRET: null,
            },
          });
      } else if (name === "READ_FROM_ATTACHMENT" && value === "FROM_EMAIL") {
        setDecompressionDir("");
        setDecompression(false);
        setShowPassword(false);
        setPassword("");

        setContent({
          add: {
            [name]: value,
            DECOMPRESSION_DIRECTORY: null,
            ZIP_PASSWORD: null,
            ZIP: "",
            USE_ZIP_PASSWORD: null,
            SPECIFY_DECOMPRESSION_DIRECTORY: null,
          },
        });
      } else if (name === "SSL") {
        if (protocol === "IMAP") {
          value === "TRUE"
            ? setContent({ add: { [name]: value, PORT: "993" } })
            : setContent({ add: { [name]: value, PORT: "143" } });
        } else if (protocol === "POP3") {
          value === "TRUE"
            ? setContent({ add: { [name]: value, PORT: "995" } })
            : setContent({
              add: {
                [name]: value,
                PORT: "110",
              },
            });
        }
      } else setContent({ [name]: value });
    } else if (screen === "SEND_DATA") {
      if (name === "ATTACHMENT_NAME") {
        if (value === "")
          setContent({ add: { FILENAME: null, OUTPUT_AS_ATTACHMENT: null } });
        else
          setContent({
            add: { FILENAME: value, OUTPUT_AS_ATTACHMENT: "TRUE" },
          });
      } else if (name === "AUTH_TYPE") {
        if (value === "GOOGLE_OAUTH2") {
          setContent({ add: { [name]: value, PASSWORD: null } });
        } else {
          setContent({
            add: { [name]: value, CREDENTIALS_JSON: null, REFRESH_TOKEN: null },
          });
        }
      } else {
        setContent({ [name]: value });
      }
    } else {
      if (name === "MAIL_TYPE") {
        let port = "";
        if (value === "POP3") {
          port = ssl ? "995" : "110";
          setContent((prev) => ({
            ...prev,
            [name]: value,
            PORT: port,
          }));
        } else if (value === "IMAP") {
          port = ssl ? "993" : "143";
          setContent((prev) => ({
            ...prev,
            [name]: value,
            PORT: port,
          }));
        } else {
          setContent((prev) => ({ 
            ...prev,
            [name]: value
          }))
        }
      } else if (name === "SSL") {
        if (protocol === "IMAP") {
          setContent((prev) => ({
            ...prev,
            [name]: value,
            PORT: value === "TRUE" ? "993" : "143",
          }));
        } else if (protocol === "POP3") {
          setContent((prev) => ({
            ...prev,
            [name]: value,
            PORT: value === "TRUE" ? "995" : "110",
          }));
        }
      } else {
        setContent((prev) => ({
          ...prev,
          [name]: value,
        }));
      }
    }
  };

  const updateDetails = () => {
    if (screen !== "SEND_DATA") {
      dispatch(
        api.endpoints.getPdcDetail.initiate(
          {
            account,
            direction: direction,
            name: encodeURIComponent(connectionName),
          },
          { forceRefetch: true }
        )
      ).then((res) => {
        if (res?.data?.current_state === "SUCCESS" && res?.data?.data) {
          setBodyContent(res.data?.data?.props?.BODY);
          setAsHtml(
            stringToBooleanConversion(res.data?.data?.props?.HTML_CONTENT)
          );
        }
        if (res?.data?.current_state === "ERROR")
          setShowAlert({
            mssg: res.data.message,
            isOpen: true,
            type: "warning",
          });
      });
    }
    setOpenModal(false);
  };

  const handleCancel = () => {
    updateDetails();
  };

  const handleDone = (bodyContent, asHtml) => {
    if(screen === "GET_DATA" || screen === "SEND_DATA"){
    if (connectionDetails?.HTML_CONTENT !== stringifyJSONAttributes(asHtml)) {
      onInputChange("add", {
        BODY: bodyContent === "" ? null : bodyContent,
        HTML_CONTENT: stringifyJSONAttributes(asHtml),
      });
    } else {
      onInputChange("add", {
        BODY: bodyContent === "" ? null : bodyContent,
      });
    }
  }
    const body = {
      ...connectionDetails,
      BODY: bodyContent,
      HTML_CONTENT: stringifyJSONAttributes(asHtml),
    };
    
    if (screen !== "SEND_DATA") {
      onInputChange('BODY', bodyContent);
      onInputChange('HTML_CONTENT', stringifyJSONAttributes(asHtml));
      // dispatch(
      //   api.endpoints.createPdc.initiate(
      //     {
      //       account,
      //       direction: direction,
      //       name: encodeURIComponent(connectionName),
      //       body,
      //       oldPdcName: encodeURIComponent(connectionName),
      //     },
      //     { subscribe: false }
      //   )
      // ).then((res) => {
      //   if (res?.data?.current_state === "SUCCESS") updateDetails();
      //   if (res?.data?.current_state === "ERROR")
      //     setShowAlert({
      //       mssg: res.data.message,
      //       isOpen: true,
      //       type: "warning",
      //     });
      // });
    }
    setOpenModal(false);
  };

  const handleAlertClose = () => {
    setShowAlert({ ...showAlert, isOpen: false });
  };
  const handleAuthTypeChange = (e) => {
    const value = e.target.value;
    setAuthType(value);
    onInputChange("AUTH_TYPE", value);

    if (value === "BASIC_AUTH") {
      if (screen !== "GET_DATA") {
        onInputChange("TENANT_ID", "");
        onInputChange("CLIENT_ID", "");
        onInputChange("CLIENT_SECRET", "");
        onInputChange("REFRESH_TOKEN", "");
        onInputChange("CREDENTIALS_JSON", "");
      }

      setTenantId("");

      setClientId("");

      setClientSecret("");
      setRefreshToken("");
      setCredentialsJson("");
    }
    if (value === "GOOGLE_OAUTH2") {
      setRefreshToken("");
      setCredentialsJson("");
    }
    if (value !== "BASIC_AUTH") {
      if (screen !== "GET_DATA") onInputChange("PASSWORD", "");
      setPass("");
    }
  };
  const handleDestinationAuthTypeChange = (e) => {
    const value = e.target.value;
    setAuthType(value);
    onInputChange("AUTH_TYPE", value);
    if (value !== "BASIC_AUTH") {
      if (screen !== "SEND_DATA") onInputChange("PASSWORD", "");
      setPass("");
    } else {
      if (screen !== "SEND_DATA") {
        onInputChange("CREDENTIALS_JSON", "");
        onInputChange("REFRESH_TOKEN", "");
      }
      setCredentialsJson("");
      setRefreshToken("");
    }
  };
  const handleDecompressionChange = (checked) => {
    setDecompression(checked);

    if (checked) {
      onInputChange("ZIP", "ZIP");
    } else {
      setShowDecompressionDir(false);
      setDecompressionDir("");
      setShowPassword(false);
      setPassword("");
      if (screen && screen === "GET_DATA") {
        onInputChange("add", {
          ZIP: null,
          SPECIFY_DECOMPRESSION_DIRECTORY: "FALSE",
          DECOMPRESSION_DIRECTORY: null,
          USE_ZIP_PASSWORD: "FALSE",
          ZIP_PASSWORD: "",
        });
      } else {
        onInputChange("ZIP", "");
        onInputChange(
          "SPECIFY_DECOMPRESSION_DIRECTORY",
          stringifyJSONAttributes(false)
        );
        onInputChange("DECOMPRESSION_DIRECTORY", "");
        onInputChange("USE_ZIP_PASSWORD", stringifyJSONAttributes(false));
        onInputChange("ZIP_PASSWORD", "");
      }
    }
  };
  const handleCompressionChange = (checked) => {
    setCompression(checked);
    if(checked){
      onInputChange("ZIP", "ZIP");
    } else {
      setCompressionType("ZIP");
      setFileNameZip("");
      setShowDestinationPassword(false);
      setDestinationPassword("");
      if(screen && screen === 'SEND_DATA'){
        onInputChange('add',{ZIP: null, USE_ZIP_PASSWORD:'FALSE', ZIP_PASSWORD: null, FILE_NAME_WITHIN_ZIP: null})
      } else {
        onInputChange("ZIP", "");
        onInputChange("FILE_NAME_WITHIN_ZIP", "");
        onInputChange("ZIP_PASSWORD", "");
        onInputChange("USE_ZIP_PASSWORD",stringifyJSONAttributes(false));
      }
      
    }
  }
  const handleCompressionTypeChange = (value) => {
    setCompressionType(value);
    if(["GZ", "TAR", "TGZ"].includes(value)){
      setShowDestinationPassword(false);
      setDestinationPassword("");
      if(screen && screen === 'SEND_DATA'){
        onInputChange('add',{ZIP: value, USE_ZIP_PASSWORD:'FALSE', ZIP_PASSWORD: null})
      } else {
        onInputChange("ZIP", value);
        onInputChange("USE_ZIP_PASSWORD",stringifyJSONAttributes(false));
        onInputChange("ZIP_PASSWORD", "");
      }
    } else {
      onInputChange("ZIP", value);
    }
  }
  const handleSendDataChange = (value) => {
    setSendData(value);
    if(value === t("LBL_AS_ATTACHMENT")) onInputChange("OUTPUT_AS_ATTACHMENT", stringifyJSONAttributes(true));
    else {
      setAttachments("");
      setCompression(false);
      setCompressionType('ZIP');
      setShowDestinationPassword(false);
      setDestinationPassword("");
      setFileNameZip("");
      if(screen && screen === 'SEND_DATA'){
        onInputChange('add',{OUTPUT_AS_ATTACHMENT: 'FALSE', FILENAME: null, COMPRESSION: 'FALSE', ZIP: null, USE_ZIP_PASSWORD: 'FALSE', ZIP_PASSWORD: null, FILE_NAME_WITHIN_ZIP: null})
      } else {
        onInputChange("OUTPUT_AS_ATTACHMENT", stringifyJSONAttributes(false));
        onInputChange("FILENAME", null);
        onInputChange("COMPRESSION", stringifyJSONAttributes(false));
        onInputChange("ZIP", null);
        onInputChange("USE_ZIP_PASSWORD", stringifyJSONAttributes(false));
        onInputChange("ZIP_PASSWORD", null);
        onInputChange("FILE_NAME_WITHIN_ZIP", null);
      }
    }
  }
  const handleUseAuthenticationChange = (value) => {
    setAuthentication(value);
    if(value) onInputChange("REQUIRES_AUTHENTICATION", stringifyJSONAttributes(true));
    else{
      if(screen &&  screen === 'SEND_DATA'){
        // Keep authentication field values intact while only disabling auth usage.
        onInputChange("add", { REQUIRES_AUTHENTICATION: "FALSE" });
      } else {
        onInputChange("REQUIRES_AUTHENTICATION", stringifyJSONAttributes(false));
      }
    }
  }

  useEffect(() => {
    // setMailServer(connectionDetails?.CONNECTIONSTRING || `http://[SERVER_URL]/services/${account}/`);
    setMailServer(connectionDetails?.CONNECTIONSTRING || "");
    setSsl(stringToBooleanConversion(connectionDetails?.SSL));
    setTls(stringToBooleanConversion(connectionDetails?.TLS));
    setUser(connectionDetails?.USERNAME || "");
    setMailType(connectionDetails?.MAIL_TYPE || "SMTP");
    // setAuthType(connectionDetails?.CIPHER_SUITE || 'OUTLOOK_OAUTH2');
    setAuthType(connectionDetails?.AUTH_TYPE || "BASIC_AUTH");
    setPass(
      connectionDetails?.PASSWORD
        ? shouldEncryptDecryptPassword
          ? decryptString(
            connectionDetails?.PASSWORD,
            process.env.REACT_APP_SECRET_KEY2
          )
          : connectionDetails?.PASSWORD
        : ""
    );
    setTenantId(connectionDetails?.TENANT_ID || "");
    setClientId(connectionDetails?.CLIENT_ID || "");
    setClientSecret(connectionDetails?.CLIENT_SECRET || "");
    setProtocol(connectionDetails?.MAIL_TYPE || "POP3");
    setEmailType(connectionDetails?.GET_EMAIL_TYPE || "ALL");
    setAfterReading(connectionDetails?.AFTER_READ_ACTION || "DELETED");
    setReadData(connectionDetails?.READ_FROM_ATTACHMENT || "FROM_EMAIL");
    setDecompressionDir(connectionDetails?.DECOMPRESSION_DIRECTORY || "");
    if (
      (connectionDetails?.DECOMPRESSION_DIRECTORY &&
        connectionDetails?.DECOMPRESSION_DIRECTORY?.length !== 0) ||
      stringToBooleanConversion(
        connectionDetails?.SPECIFY_DECOMPRESSION_DIRECTORY
      )
    )
      setShowDecompressionDir(true);
    else setShowDecompressionDir(false);
    setShowPassword(
      stringToBooleanConversion(connectionDetails?.USE_ZIP_PASSWORD)
    );
    setPassword(
      connectionDetails?.ZIP_PASSWORD
        ? decryptString(
          connectionDetails?.ZIP_PASSWORD,
          process.env.REACT_APP_SECRET_KEY2
        )
        : ""
    );
    setSmtpMailServer(connectionDetails?.CONNECTIONSTRING || "");
    setTo(connectionDetails?.TO_EMAIL || "");
    setFrom(connectionDetails?.FROM_EMAIL || "");
    setCc(connectionDetails?.CC_EMAIL || "");
    setBcc(connectionDetails?.BCC_EMAIL || "");
    setSubject(connectionDetails?.SUBJECT || "");
    setMessageId(connectionDetails?.MESSAGE_ID || "");
    setAsHtml(stringToBooleanConversion(connectionDetails?.HTML_CONTENT));
    setBodyContent(connectionDetails?.BODY || "");
    setAttachments(connectionDetails?.FILENAME || "");
    setCredentialsJson(connectionDetails?.CREDENTIALS_JSON || "");
    setRefreshToken(connectionDetails?.REFRESH_TOKEN || "");
    if (connectionDetails?.REQUIRES_AUTHENTICATION)
      setAuthentication(
        stringToBooleanConversion(connectionDetails?.REQUIRES_AUTHENTICATION) ||
        false
      );
    else setAuthentication(false);
    setFileNameZip(connectionDetails?.FILE_NAME_WITHIN_ZIP || "");
    if (connectionDetails?.ZIP) {
      setCompressionType(connectionDetails?.ZIP || "");
      setDecompression(true);
      setCompression(true);
    } else {
      setDecompression(false);
      setCompressionType("");
      setCompression(false);
    }
    if (direction === "OUT") {
      setShowDestinationPassword(
        stringToBooleanConversion(connectionDetails?.USE_ZIP_PASSWORD)
      );
      setDestinationPassword(connectionDetails?.ZIP_PASSWORD ? decryptString(connectionDetails?.ZIP_PASSWORD, process.env.REACT_APP_SECRET_KEY2) : "");
      // setCompression(stringToBooleanConversion(connectionDetails?.COMPRESSION) || false);
      setCompression(connectionDetails?.ZIP ? true : false);
      setCompressionType(connectionDetails?.ZIP || "ZIP");
      setPassword(
        connectionDetails?.PASSWORD
          ? shouldEncryptDecryptPassword
            ? decryptString(
              connectionDetails?.PASSWORD,
              process.env.REACT_APP_SECRET_KEY2
            )
            : connectionDetails?.PASSWORD
          : ""
      );

    }

    if (stringToBooleanConversion(connectionDetails?.OUTPUT_AS_ATTACHMENT))
      setSendData(t("LBL_AS_ATTACHMENT"));
    else setSendData(t("LBL_INSIDE_BODY"));
    setContent({ ...connectionDetails });
  }, [connectionDetails]);

  useEffect(() => {
    if (direction === "OUT") {
      dispatch(api.endpoints.getCompressionList.initiate()).then((res) => {
        if (res?.data?.current_state === "SUCCESS") {
          const types = Object.values(res?.data?.data)?.map(
            (item) => item?.TYPE
          );
          setCompressionList(types);
        }
        if (res?.data?.current_state === "ERROR") {
          setShowAlert({
            mssg: res?.data?.message,
            isOpen: true,
            type: "error",
          });
        }
      });
    }
  }, [direction]);

  useEffect(() => {
    if (!_.isEqual(content, connectionDetails)) debouncedContentUpdate(content);
  }, [content]);

  const workflowMappings = {
    [t("LBL_MAIL_SERV")]: {
      stateSetter: setMailServer,
      key: "CONNECTIONSTRING",
      value: mailServer,
      inputType: "text",
    },
    [t("LBL_SMTP_MAIL_SERV")]: {
      stateSetter: setSmtpMailServer,
      key: "CONNECTIONSTRING",
      value: smtpMailServer,
      inputType: "text",
    },
    [t("LBL_USR_EMAIL_ADDR")]: {
      stateSetter: setUser,
      key: "USERNAME",
      value: user,
      inputType: "text",
    },
    [t("LBL_WS_PASSWORD")]: {
      stateSetter: setPass,
      key: "PASSWORD",
      value: pass,
      inputType: "password",
      specialPasswordField: true,
    },
    [t("LBL_AUTH_TYPE")]: {
      stateSetter: setAuthType,
      key: "AUTH_TYPE",
      value: authType,
      inputType: "text",
    },
    [t("LBL_TENANT_ID")]: {
      stateSetter: setTenantId,
      key: "TENANT_ID",
      value: tenandId,
      inputType: "text",
      specialPasswordField: true,
    },
    [t("LBL_CLIENT_ID_CONFIG")]: {
      stateSetter: setClientId,
      key: "CLIENT_ID",
      value: clientId,
      inputType: "text",
      specialPasswordField: true,
    },
    [t("LBL_CLIENT_SECRET")]: {
      stateSetter: setClientSecret,
      key: "CLIENT_SECRET",
      value: clientSecret,
      inputType: "text",
      specialPasswordField: true,
    },
    [t("LBL_DECOMPRESS_DIRECTORY")]: {
      stateSetter: setDecompressionDir,
      key: "DECOMPRESSION_DIRECTORY",
      value: decompressionDir,
      inputType: "text",
    },
    [t("PASSWORD_")]: {
      stateSetter: setPassword,
      key: "ZIP_PASSWORD",
      value: password,
      inputType: "password",
      specialPasswordField: true,
    },
    [t("PASSWORD")]: {
      stateSetter: setPass,
      key: "PASSWORD",
      value: pass,
      inputType: "password",
      specialPasswordField: true,
    },
    [t("LBL_ATTACHMENT_NAME")]: {
      stateSetter: setAttachments,
      key: "ATTACHMENT_NAME",
      value: attachments,
      inputType: "text",
    },
    [t("LBL_CREDENTIALS_JSON")]: {
      stateSetter: setCredentialsJson,
      key: "CREDENTIALS_JSON",
      value: credentialsJson,
      inputType: "text",
      specialPasswordField: true,
    },
    [t("LBL_REFRESH_TOKEN")]: {
      stateSetter: setRefreshToken,
      key: "REFRESH_TOKEN",
      value: refreshToken,
      inputType: "text",
      specialPasswordField: true,
    },
    [t("LBL_TO")]: {
      stateSetter: setTo,
      key: "TO_EMAIL",
      value: to,
      inputType: "text",
    },
    [t("LBL_FROM")]: {
      stateSetter: setFrom,
      key: "FROM_EMAIL",
      value: from,
      inputType: "text",
    },
    [t("LBL_CC")]: {
      stateSetter: setCc,
      key: "CC_EMAIL",
      value: cc,
      inputType: "text",
    },
    [t("LBL_BCC")]: {
      stateSetter: setBcc,
      key: "BCC_EMAIL",
      value: bcc,
      inputType: "text",
    },
    [t("LBL_SUBJECT")]: {
      stateSetter: setSubject,
      key: "SUBJECT",
      value: subject,
      inputType: "text",
    },
    [t("LBL_SMTP_ID")]: {
      stateSetter: setMessageId,
      key: "MESSAGE_ID",
      value: messageId,
      inputType: "text",
    },
  };
  const getCurrentMaskLength = (label) => {
    const keyMap = {
      [t("LBL_TENANT_ID")]: 'TENANT_ID',
      [t("LBL_CLIENT_ID_CONFIG")]: 'CLIENT_ID', 
      [t("LBL_CLIENT_SECRET")]: 'CLIENT_SECRET',
      [t("LBL_CREDENTIALS_JSON")]: 'CREDENTIALS_JSON',
      [t("LBL_REFRESH_TOKEN")]: 'REFRESH_TOKEN',
    };
    
    const key = keyMap[label];
    if (!key) return 0;
    
    // Return the original length of the value from connectionDetails
    // This ensures that when the modal opens, it shows existing content masked
    // and any new content that was typed in the Email field as visible
    const originalValue = connectionDetails?.[key] || "";
    return originalValue.length;
  };

  const valuesHandler = (value) => {
    if (workflowMappings[valueLabel]) {
      const { stateSetter, key } = workflowMappings[valueLabel];
      let encryptedValue = value;
      if (key === "ZIP_PASSWORD" || (key === "PASSWORD" && shouldEncryptDecryptPassword)) {
        encryptedValue = encryptString(value, process.env.REACT_APP_SECRET_KEY2);
      } else if (key === "ATTACHMENT_NAME" && value !== "") {
        onInputChange({
          add: { FILENAME: value, OUTPUT_AS_ATTACHMENT: "TRUE" },
        });
      }
      stateSetter(value);
      onInputChange(key, encryptedValue);
    }
  };


  const getFontWeight = (
    control,
    currentValue,
    defaultValue,
    useConnection
  ) => {
    if (!repoPDC) return "normal";
    if (!(control in repoPDC) && currentValue === defaultValue) return "normal";
    return (repoPDC?.[control] !== currentValue || !(control in repoPDC)) &&
      useConnection === "preDefined"
      ? "bold"
      : "normal";
  };
  const fontWeights = useMemo(
    () => ({
      CONNECTIONSTRING: getFontWeight(
        "CONNECTIONSTRING",
        mailServer,
        "",
        useConnection
      ),
      USERNAME: getFontWeight("USERNAME", user, "", useConnection),
      AUTH_TYPE: getFontWeight(
        "AUTH_TYPE",
        authType,
        "BASIC_AUTH",
        useConnection
      ),
      PASSWORD: getFontWeight(
        "PASSWORD",
        direction === "OUT" ? password : pass,
        "",
        useConnection
      ),
      TENANT_ID: getFontWeight("TENANT_ID", tenandId, "", useConnection),
      CLIENT_ID: getFontWeight("CLIENT_ID", clientId, "", useConnection),
      CLIENT_SECRET: getFontWeight(
        "CLIENT_SECRET",
        clientSecret,
        "",
        useConnection
      ),
      MAIL_TYPE: getFontWeight("MAIL_TYPE", protocol, "POP3", useConnection),
      GET_EMAIL_TYPE: getFontWeight(
        "GET_EMAIL_TYPE",
        emailType,
        "ALL",
        useConnection
      ),
      AFTER_READ: getFontWeight(
        "AFTER_READ",
        afterReading,
        "DELETED",
        useConnection
      ),
      READ_FROM_ATTACHMENT: getFontWeight(
        "READ_FROM_ATTACHMENT",
        readData,
        "FROM_EMAIL",
        useConnection
      ),
      DECOMPRESSION_DIRECTORY: getFontWeight(
        "DECOMPRESSION_DIRECTORY",
        decompressionDir,
        "",
        useConnection
      ),
      ZIP_PASSWORD: getFontWeight("ZIP_PASSWORD", password, "", useConnection),
      // SEND_DATA specific fields
      TO_EMAIL: getFontWeight("TO_EMAIL", to, "", useConnection),
      FROM_EMAIL: getFontWeight("FROM_EMAIL", from, "", useConnection),
      CC_EMAIL: getFontWeight("CC_EMAIL", cc, "", useConnection),
      BCC_EMAIL: getFontWeight("BCC_EMAIL", bcc, "", useConnection),
      SUBJECT: getFontWeight("SUBJECT", subject, "", useConnection),
      MESSAGE_ID: getFontWeight("MESSAGE_ID", messageId, "", useConnection),
      ATTACHMENT_NAME: getFontWeight(
        "ATTACHMENT_NAME",
        attachments,
        "",
        useConnection
      ),
      CREDENTIALS_JSON: getFontWeight(
        "CREDENTIALS_JSON",
        credentialsJson,
        "",
        useConnection
      ),
      REFRESH_TOKEN: getFontWeight(
        "REFRESH_TOKEN",
        refreshToken,
        "",
        useConnection
      ),
    }),
    [
      mailServer,
      user,
      authType,
      pass,
      tenandId,
      clientId,
      clientSecret,
      protocol,
      afterReading,
      readData,
      emailType,
      decompressionDir,
      password,
      to,
      from,
      cc,
      bcc,
      subject,
      messageId,
      attachments,
      credentialsJson,
      refreshToken,
      connectionDetails,
      useConnection,
      repoPDC,
    ]
  );

  return (
    <>
      {direction === "IN" && (
        <div style={{ display: "flex", gap: "4px" }}>
          <FormControl className="width-100" size="small">
            <TextField
              variant="outlined"
              size="small"
              label={t("LBL_MAIL_SERV")}
              type="text"
              value={mailServer || ""}
              onChange={(e) => {
                onInputChange(e.target.name, e.target.value);
                setMailServer(e.target.value);
              }}
              className={"width-100"}
              name={"CONNECTIONSTRING"}
              autoComplete="off"
              disabled={disableControl || (protocol === "MS_GRAPH" && direction === "IN") || (mailType === "MS_GRAPH" && direction === "OUT")}
              sx={{ input: { fontWeight: fontWeights.CONNECTIONSTRING } }}
            />
          </FormControl>
          {screen && screen === "GET_DATA" && (
            <Button
              size="small"
              disabled={disableControl || (protocol === "MS_GRAPH" && direction === "IN") || (mailType === "MS_GRAPH" && direction === "OUT")}
              variant="outlined"
              onClick={() => {
                setValueLabel(t("LBL_MAIL_SERV"));
                setWorkflowSessionModal({ open: true, isFirstTime: true });
              }}
              sx={{ width: "40px", minWidth: "40px" }}>
              <MoreHorizOutlined fontSize="small" />
            </Button>
          )}
        </div>
      )}
      {direction === "OUT" && (
        <div style={{ display: "flex", gap: "4px" }}>
          <FormControl className="width-100" size="small">
            <TextField
              variant="outlined"
              size="small"
              label={t("LBL_SMTP_MAIL_SERV")}
              type="text"
              value={smtpMailServer || ""}
              onChange={(e) => {
                onInputChange(e.target.name, e.target.value);
                setSmtpMailServer(e.target.value);
              }}
              className={"width-100"}
              name={"CONNECTIONSTRING"}
              autoComplete="off"
              disabled={disableControl || (protocol === "MS_GRAPH" && direction === "IN") || (mailType === "MS_GRAPH" && direction === "OUT")}
              sx={{ input: { fontWeight: fontWeights.CONNECTIONSTRING } }}
            />
          </FormControl>
          {screen && screen === "SEND_DATA" && (
            <Button
              size="small"
              disabled={disableControl || (protocol === "MS_GRAPH" && direction === "IN") || (mailType === "MS_GRAPH" && direction === "OUT")}
              variant="outlined"
              onClick={() => {
                setValueLabel(t("LBL_SMTP_MAIL_SERV"));
                setWorkflowSessionModal({ open: true, isFirstTime: true });
              }}
              sx={{ width: "40px", minWidth: "40px" }}>
              <MoreHorizOutlined fontSize="small" />
            </Button>
          )}
        </div>
      )}
      <div className="flex flex-wrap">
        <TPCheckbox
          label={t("BTN_SSL")}
          checked={ssl}
          disabled={disableControl || (protocol === "MS_GRAPH" && direction === "IN") || (mailType === "MS_GRAPH" && direction === "OUT")}
          handleCheck={(checked) => {
            onInputChange("SSL", stringifyJSONAttributes(checked));
            setSsl(checked);
          }}
        />
        <TPCheckbox
          label={t("BTN_TLS")}
          checked={tls}
          disabled={disableControl || (protocol === "MS_GRAPH" && direction === "IN") || (mailType === "MS_GRAPH" && direction === "OUT")}
          handleCheck={(checked) => {
            onInputChange("TLS", stringifyJSONAttributes(checked));
            setTls(checked);
          }}
        />
      </div>
      {direction === "IN" && (
        <div style={{ display: "flex", gap: "4px" }}>
          <FormControl className="width-100" size="small">
            <TextField
              variant="outlined"
              size="small"
              label={t("LBL_USR_EMAIL_ADDR")}
              type="text"
              value={user || ""}
              onChange={(e) => {
                onInputChange("USERNAME", e.target.value);
                setUser(e.target.value);
              }}
              className={"width-100"}
              name={"USER_NAME"}
              autoComplete="off"
              disabled={disableControl}
              sx={{ input: { fontWeight: fontWeights.USERNAME } }}
            />
          </FormControl>
          {screen && screen === "GET_DATA" && (
            <Button
              size="small"
              disabled={disableControl || false}
              variant="outlined"
              onClick={() => {
                setValueLabel(t("LBL_USR_EMAIL_ADDR"));
                setWorkflowSessionModal({ open: true, isFirstTime: true });
              }}
              sx={{ width: "40px", minWidth: "40px" }}>
              <MoreHorizOutlined fontSize="small" />
            </Button>
          )}
        </div>
      )}
      {direction === "OUT" && (
        <>
          <div style={{ display: "flex", gap: "4px" }}>
            <FormControl className="width-100" size="small">
              <TextField
                variant="outlined"
                size="small"
                label={t("LBL_TO")}
                type="text"
                value={to || ""}
                onChange={(e) => {
                  onInputChange(e.target.name, e.target.value);
                  setTo(e.target.value);
                }}
                className={"width-100"}
                name={"TO_EMAIL"}
                autoComplete="off"
                disabled={disableControl}
                sx={{ input: { fontWeight: fontWeights.TO_EMAIL } }}
              />
            </FormControl>
            {screen && screen === "SEND_DATA" && (
              <Button
                size="small"
                disabled={disableControl || false}
                variant="outlined"
                onClick={() => {
                  setValueLabel(t("LBL_TO"));
                  setWorkflowSessionModal({ open: true, isFirstTime: true });
                }}
                sx={{ width: "40px", minWidth: "40px" }}>
                <MoreHorizOutlined fontSize="small" />
              </Button>
            )}
          </div>
          <div style={{ display: "flex", gap: "4px" }}>
            <FormControl className="width-100" size="small">
              <TextField
                variant="outlined"
                size="small"
                label={t("LBL_FROM")}
                type="text"
                value={from || ""}
                onChange={(e) => {
                  onInputChange(e.target.name, e.target.value);
                  setFrom(e.target.value);
                }}
                className={"width-100"}
                name={"FROM_EMAIL"}
                autoComplete="off"
                disabled={disableControl}
                sx={{ input: { fontWeight: fontWeights.FROM_EMAIL } }}
              />
            </FormControl>
            {screen && screen === "SEND_DATA" && (
              <Button
                size="small"
                disabled={disableControl || false}
                variant="outlined"
                onClick={() => {
                  setValueLabel(t("LBL_FROM"));
                  setWorkflowSessionModal({ open: true, isFirstTime: true });
                }}
                sx={{ width: "40px", minWidth: "40px" }}>
                <MoreHorizOutlined fontSize="small" />
              </Button>
            )}
          </div>
          <div style={{ display: "flex", gap: "4px" }}>
            <FormControl className="width-100" size="small">
              <TextField
                variant="outlined"
                size="small"
                label={t("LBL_CC")}
                type="text"
                value={cc || ""}
                onChange={(e) => {
                  onInputChange(e.target.name, e.target.value);
                  setCc(e.target.value);
                }}
                className={"width-100"}
                name={"CC_EMAIL"}
                autoComplete="off"
                disabled={disableControl}
                sx={{ input: { fontWeight: fontWeights.CC_EMAIL } }}
              />
            </FormControl>
            {screen && screen === "SEND_DATA" && (
              <Button
                size="small"
                disabled={disableControl || false}
                variant="outlined"
                onClick={() => {
                  setValueLabel(t("LBL_CC"));
                  setWorkflowSessionModal({ open: true, isFirstTime: true });
                }}
                sx={{ width: "40px", minWidth: "40px" }}>
                <MoreHorizOutlined fontSize="small" />
              </Button>
            )}
          </div>
          <div style={{ display: "flex", gap: "4px" }}>
            <FormControl className="width-100" size="small">
              <TextField
                variant="outlined"
                size="small"
                label={t("LBL_BCC")}
                type="text"
                value={bcc || ""}
                onChange={(e) => {
                  onInputChange(e.target.name, e.target.value);
                  setBcc(e.target.value);
                }}
                className={"width-100"}
                name={"BCC_EMAIL"}
                autoComplete="off"
                disabled={disableControl}
                sx={{ input: { fontWeight: fontWeights.BCC_EMAIL } }}
              />
            </FormControl>
            {screen && screen === "SEND_DATA" && (
              <Button
                size="small"
                disabled={disableControl || false}
                variant="outlined"
                onClick={() => {
                  setValueLabel(t("LBL_BCC"));
                  setWorkflowSessionModal({ open: true, isFirstTime: true });
                }}
                sx={{ width: "40px", minWidth: "40px" }}>
                <MoreHorizOutlined fontSize="small" />
              </Button>
            )}
          </div>
          <div style={{ display: "flex", gap: "4px" }}>
            <FormControl className="width-100" size="small">
              <TextField
                variant="outlined"
                size="small"
                label={t("LBL_SUBJECT")}
                type="text"
                value={subject || ""}
                onChange={(e) => {
                  onInputChange(e.target.name, e.target.value);
                  setSubject(e.target.value);
                }}
                className={"width-100"}
                name={"SUBJECT"}
                autoComplete="off"
                disabled={disableControl}
                sx={{ input: { fontWeight: fontWeights.SUBJECT } }}
              />
            </FormControl>
            {screen && screen === "SEND_DATA" && (
              <Button
                size="small"
                disabled={disableControl || false}
                variant="outlined"
                onClick={() => {
                  setValueLabel(t("LBL_SUBJECT"));
                  setWorkflowSessionModal({ open: true, isFirstTime: true });
                }}
                sx={{ width: "40px", minWidth: "40px" }}>
                <MoreHorizOutlined fontSize="small" />
              </Button>
            )}
          </div>
          <div style={{ display: "flex", gap: "4px" }}>
            <FormControl className="width-100" size="small">
              <TextField
                variant="outlined"
                size="small"
                label={t("LBL_SMTP_ID")}
                type="text"
                value={messageId || ""}
                onChange={(e) => {
                  onInputChange(e.target.name, e.target.value);
                  setMessageId(e.target.value);
                }}
                className={"width-100"}
                name={"MESSAGE_ID"}
                autoComplete="off"
                disabled={disableControl}
                sx={{ input: { fontWeight: fontWeights.MESSAGE_ID } }}
              />
            </FormControl>
            {screen && screen === "SEND_DATA" && (
              <Button
                size="small"
                disabled={disableControl || false}
                variant="outlined"
                onClick={() => {
                  setValueLabel(t("LBL_SMTP_ID"));
                  setWorkflowSessionModal({ open: true, isFirstTime: true });
                }}
                sx={{ width: "40px", minWidth: "40px" }}>
                <MoreHorizOutlined fontSize="small" />
              </Button>
            )}
          </div>
          <FormControl variant="outlined" className="width-100" size="small">
            <InputLabel id="sendDataLabel">{t("LBL_SEND_DATA")}</InputLabel>
            <Select
              className={"width-100"}
              MenuProps={{
                PaperProps: {
                  sx: {
                    maxHeight: 300,
                  },
                },
              }}
              name={"OUTPUT_AS_ATTACHMENT"}
              labelId="sendDataLabel"
              label={t("LBL_SEND_DATA")}
              id="sendData"
              value={sendData}
              disabled={disableControl}
              onChange={(e) => { handleSendDataChange(e.target.value) }}>
              {["LBL_INSIDE_BODY", "LBL_AS_ATTACHMENT"]?.map((obj, key) => (
                <MenuItem key={key} value={t(obj)}>
                  {t(obj)}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Button
            className="width-100"
            size="small"
            variant="outlined"
            disabled={disableControl}
            onClick={() => setOpenModal(true)}>
            {t("BTN_ENTER_EMAIL_BODY_HERE")}
          </Button>
          {sendData === t("LBL_AS_ATTACHMENT") && (
            <div style={{ display: "flex", gap: "4px" }}>
              <FormControl className="width-100" size="small">
                <TextField
                  variant="outlined"
                  size="small"
                  label={t("LBL_ATTACHMENT_NAME")}
                  type="text"
                  value={attachments || ""}
                  onChange={(e) => {
                    onInputChange(e.target.name, e.target.value);
                    setAttachments(e.target.value);
                  }}
                  className={"width-100"}
                  name={"FILENAME"}
                  autoComplete="off"
                  disabled={disableControl}
                  sx={{ input: { fontWeight: fontWeights.ATTACHMENT_NAME } }}
                />
              </FormControl>
              {screen && screen === "SEND_DATA" && (
                <Button
                  size="small"
                  disabled={disableControl || false}
                  variant="outlined"
                  onClick={() => {
                    setValueLabel(t("LBL_ATTACHMENT_NAME"));
                    setWorkflowSessionModal({ open: true, isFirstTime: true });
                  }}
                  sx={{ width: "40px", minWidth: "40px" }}>
                  <MoreHorizOutlined fontSize="small" />
                </Button>
              )}
            </div>
          )}
          <div className="flex flex-wrap">
            <TPCheckbox
              label={t("BTN_USE_AUTHENTICATION")}
              checked={authentication}
              disabled={disableControl}
              handleCheck={(checked) => {
                handleUseAuthenticationChange(checked);
              }}
            />
            {sendData === t("LBL_AS_ATTACHMENT") && (
              <TPCheckbox
                label={t("BTN_USE_ZIP_COMPRESS")}
                checked={compression}
                disabled={disableControl}
                handleCheck={(checked) => {handleCompressionChange(checked) }}
              />
            )}
          </div>
          {compression && direction === "OUT" && (
            <>
              <Autocomplete
                disablePortal
                options={compressionList}
                getOptionLabel={(option) => option}
                value={compressionType}
                sx={{ maxHeight: 300 }}
                disabled={disableControl}
                onChange={(e, value) => {
                  handleCompressionTypeChange(value);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={t("LBL_COMPRESSION_TYPE")}
                    onChange={(e) => {
                      const value = e.target.value;
                      handleCompressionTypeChange(value);
                    }}
                    variant="outlined"
                    size="small"
                    name={"COMPRESSION_TYPE"}
                    autoComplete="off"
                  />
                )}
              />
              <FormControl className="width-100" size="small">
                <TextField
                  variant="outlined"
                  size="small"
                  label={t("FILE_NAME_WITHIN_ZIP")}
                  type="text"
                  value={fileNameZip || ""}
                  onChange={(e) => {
                    onInputChange(e.target.name, e.target.value);
                    setFileNameZip(e.target.value);
                  }}
                  className={"width-100"}
                  name={"FILE_NAME_WITHIN_ZIP"}
                  autoComplete="off"
                  disabled={disableControl}
                />
              </FormControl>
              {["JAR", "RAR", "ZIP"].includes(compressionType) && (
                <>
                  <div>
                    <TPCheckbox
                      label={t("LBL_WS_PASSWORD")}
                      checked={showDestinationPassword}
                      disabled={disableControl}
                      handleCheck={(checked) => {
                        onInputChange(
                          "USE_ZIP_PASSWORD",
                          stringifyJSONAttributes(checked)
                        );
                        setShowDestinationPassword(checked);
                        if (!checked) {
                          onInputChange("ZIP_PASSWORD", "");
                          setDestinationPassword("");
                        }
                      }}
                    />
                  </div>
                  {showDestinationPassword && (
                    <SmartPasswordField
                      variant="outlined"
                      size="small"
                      value={destinationPassword || ""}
                      onChange={(e) => {
                        onInputChange(e.target.name, encryptString(e.target.value, process.env.REACT_APP_SECRET_KEY2));
                        setDestinationPassword(e.target.value);
                      }}
                      className={"width-100"}
                      name={"ZIP_PASSWORD"}
                      autoComplete="off"
                      disabled={disableControl}
                    />
                  )}
                </>
              )}
            </>
          )}
          {authentication && direction === "OUT" && (
            <>
              <FormControl className="width-100" size="small">
                <TextField
                  variant="outlined"
                  size="small"
                  label={t("LBL_USR_EMAIL_ADDR")}
                  type="text"
                  value={user || ""}
                  onChange={(e) => {
                    onInputChange("USERNAME", e.target.value);
                    setUser(e.target.value);
                  }}
                  className={"width-100"}
                  name={"USER_NAME"}
                  autoComplete="off"
                  disabled={disableControl}
                  sx={{ input: { fontWeight: fontWeights.USERNAME } }}
                />
              </FormControl>

              <FormControl
                variant="outlined"
                className="width-100"
                size="small">
                <InputLabel id="authTypeOutDropdownLabel">
                  {t("AUTH_TYPE")}
                </InputLabel>
                <Select
                  className={"width-100"}
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        maxHeight: 300,
                      },
                    },
                  }}
                  name={"AUTH_TYPE"}
                  labelId="authTypeOutDropdownLabel"
                  label={t("AUTH_TYPE")}
                  id="authTypeOutDropdown"
                  value={authType}
                  onChange={handleDestinationAuthTypeChange}
                  disabled={disableControl}
                  sx={{ "& .MuiSelect-select": { fontWeight: fontWeights.AUTH_TYPE } }}>
                  <MenuItem value="BASIC_AUTH">BASIC_AUTH</MenuItem>
                  <MenuItem value="OUTLOOK_OAUTH2">OUTLOOK_OAUTH2</MenuItem>
                  <MenuItem value="GOOGLE_OAUTH2">
                    {t("GOOGLE_OAUTH2")}
                  </MenuItem>
                </Select>
              </FormControl>

              {authType === "BASIC_AUTH" && (
                <SmartPasswordField
                  variant="outlined"
                  size="small"
                  label={t("LBL_WS_PASSWORD")}
                  value={password || ""}
                  onChange={(e) => {
                    onInputChange(
                      e.target.name,
                      shouldEncryptDecryptPassword
                        ? encryptString(
                          e.target.value,
                          process.env.REACT_APP_SECRET_KEY2
                        )
                        : e.target.value
                    );
                    setPassword(e.target.value);
                  }}
                  className={"width-100"}
                  name={"PASSWORD"}
                  autoComplete="off"
                  disabled={disableControl}
                  sx={{ input: { fontWeight: fontWeights.PASSWORD } }}
                />
              )}

              {authType === t("OUTLOOK_OAUTH2") && (
                <>
                  <div style={{ display: "flex", gap: "4px" }}>
                    <SmartPasswordField
                      variant="outlined"
                      size="small"
                      label={t("LBL_TENANT_ID")}
                      type="text"
                      value={tenandId || ""}
                      onChange={(e) => {
                        onInputChange(e.target.name, e.target.value);
                        setTenantId(e.target.value);
                      }}
                      className={"width-100"}
                      name={"TENANT_ID"}
                      autoComplete="off"
                      disabled={disableControl}
                      sx={{ input: { fontWeight: fontWeights.TENANT_ID } }}

                    />
                    {screen && screen === "SEND_DATA" && (
                      <Button
                        size="small"
                        disabled={disableControl || false}
                        variant="outlined"
                        onClick={() => {
                          setValueLabel(t("LBL_TENANT_ID"));
                          setWorkflowSessionModal({
                            open: true,
                            isFirstTime: true,
                          });
                        }}
                        sx={{ width: "40px", minWidth: "40px" }}>
                        <MoreHorizOutlined fontSize="small" />
                      </Button>
                    )}
                  </div>
                  <div style={{ display: "flex", gap: "4px" }}>
                    <SmartPasswordField
                      variant="outlined"
                      size="small"
                      label={t("LBL_CLIENT_ID_CONFIG")}
                      type="text"
                      value={clientId || ""}
                      onChange={(e) => {
                        onInputChange(e.target.name, e.target.value);
                        setClientId(e.target.value);
                      }}
                      className={"width-100"}
                      name={"CLIENT_ID"}
                      autoComplete="off"
                      disabled={disableControl}
                      sx={{ input: { fontWeight: fontWeights.CLIENT_ID } }}

                    />
                    {screen && screen === "SEND_DATA" && (
                      <Button
                        size="small"
                        disabled={disableControl || false}
                        variant="outlined"
                        onClick={() => {
                          setValueLabel(t("LBL_CLIENT_ID_CONFIG"));
                          setWorkflowSessionModal({
                            open: true,
                            isFirstTime: true,
                          });
                        }}
                        sx={{ width: "40px", minWidth: "40px" }}>
                        <MoreHorizOutlined fontSize="small" />
                      </Button>
                    )}
                  </div>
                  <div style={{ display: "flex", gap: "4px" }}>
                    <SmartPasswordField
                      variant="outlined"
                      size="small"
                      label={t("LBL_CLIENT_SECRET")}
                      type="text"
                      value={clientSecret || ""}
                      onChange={(e) => {
                        onInputChange(e.target.name, e.target.value);
                        setClientSecret(e.target.value);
                      }}
                      className={"width-100"}
                      name={"CLIENT_SECRET"}
                      autoComplete="off"
                      disabled={disableControl}
                      sx={{ input: { fontWeight: fontWeights.CLIENT_SECRET } }}

                    />
                    {screen && screen === "SEND_DATA" && (
                      <Button
                        size="small"
                        disabled={disableControl || false}
                        variant="outlined"
                        onClick={() => {
                          setValueLabel(t("LBL_CLIENT_SECRET"));
                          setWorkflowSessionModal({
                            open: true,
                            isFirstTime: true,
                          });
                        }}
                        sx={{ width: "40px", minWidth: "40px" }}>
                        <MoreHorizOutlined fontSize="small" />
                      </Button>
                    )}
                  </div>
                  {
                    direction === "OUT" && (
                      <>
                        <div style={{ display: "flex", gap: "4px" }}>
                          <FormControl className="width-100" size="small">
                            <InputLabel id="protocol-select-label">{t("LBL_PROTOCOL")}</InputLabel>
                            <Select
                              labelId="protocol-select-label"
                              id="protocol-select"
                              value={mailType || "SMTP"}
                              onChange={(e) => {
                                onInputChange("MAIL_TYPE", e.target.value);
                                setMailType(e.target.value);
                              }}
                              label={t("LBL_PROTOCOL")}
                              disabled={disableControl}
                              name="PROTOCOL"
                            >
                              <MenuItem value="SMTP">SMTP</MenuItem>
                              <MenuItem value="MS_GRAPH">MS_GRAPH</MenuItem>
                            </Select>
                          </FormControl>
                          
                        </div>
                      </>
                    )
                  }
                </>
              )}

              {authType === "GOOGLE_OAUTH2" && (
                <>
                  <div style={{ display: "flex", gap: "4px" }}>
                    <SmartPasswordField
                      variant="outlined"
                      size="small"
                      multiline
                      maxRows={4}
                      label={t("LBL_CREDENTIALS_JSON")}
                      type="text"
                      value={credentialsJson || ""}
                      onChange={(e) => {
                        onInputChange(e.target.name, e.target.value);
                        setCredentialsJson(e.target.value);
                      }}
                      className={"width-100"}
                      name={"CREDENTIALS_JSON"}
                      autoComplete="off"
                      disabled={disableControl}
                      sx={{
                        input: { fontWeight: fontWeights.CREDENTIALS_JSON },
                        textarea: {
                          fontWeight: fontWeights.CREDENTIALS_JSON,
                        },
                      }}

                    />
                    {screen && screen === "SEND_DATA" && (
                      <Button
                        size="small"
                        disabled={disableControl || false}
                        variant="outlined"
                        onClick={() => {
                          setValueLabel(t("LBL_CREDENTIALS_JSON"));
                          setWorkflowSessionModal({
                            open: true,
                            isFirstTime: true,
                          });
                        }}
                        sx={{ width: "40px", minWidth: "40px" }}>
                        <MoreHorizOutlined fontSize="small" />
                      </Button>
                    )}
                  </div>

                  <div style={{ display: "flex", gap: "4px" }}>
                    <SmartPasswordField
                      variant="outlined"
                      size="small"
                      label={t("LBL_REFRESH_TOKEN")}
                      type="text"
                      value={refreshToken || ""}
                      onChange={(e) => {
                        onInputChange(e.target.name, e.target.value);
                        setRefreshToken(e.target.value);
                      }}
                      className={"width-100"}
                      name={"REFRESH_TOKEN"}
                      autoComplete="off"
                      disabled={disableControl}
                      sx={{
                        input: { fontWeight: fontWeights.REFRESH_TOKEN },
                      }}

                    />
                    {screen && screen === "SEND_DATA" && (
                      <Button
                        size="small"
                        disabled={disableControl || false}
                        variant="outlined"
                        onClick={() => {
                          setValueLabel(t("LBL_REFRESH_TOKEN"));
                          setWorkflowSessionModal({
                            open: true,
                            isFirstTime: true,
                          });
                        }}
                        sx={{ width: "40px", minWidth: "40px" }}>
                        <MoreHorizOutlined fontSize="small" />
                      </Button>
                    )}
                  </div>
                </>
              )}
            </>
          )}
        </>
      )}
      {direction === "IN" && (
        <>
          <FormControl variant="outlined" className="width-100" size="small">
            <InputLabel id="authTypeDropdownLabel">{t("AUTH_TYPE")}</InputLabel>
            <Select
              className={"width-100"}
              MenuProps={{
                PaperProps: {
                  sx: {
                    maxHeight: 300,
                  },
                },
              }}
              sx={{ "& .MuiSelect-select": { fontWeight: fontWeights.AUTH_TYPE } }}
              name={"AUTH_TYPE"}
              labelId="authTypeDropdownLabel"
              label={t("AUTH_TYPE")}
              id="authTypeDropdown"
              value={authType}
              // onChange={(e) => {
              //   const value = e.target.value;
              // //   onInputChange(e.target.name, value);
              //   onInputChange("AUTH_TYPE", value);
              //   setAuthType(value);
              //   if (value !== "OUTLOOK_OAUTH2") {
              //     onInputChange("TENANT_ID", "");
              //     setTenantId("");
              //     onInputChange("CLIENT_ID_CONFIG", "");
              //     setClientId("");
              //     onInputChange("CLIENT_SECRET", "");
              //     setClientSecret("");
              //   }
              //   if (value !== "Basic Auth") {
              //     onInputChange("PASSWORD", "");
              //     setPass("");
              //   }
              // }}
              onChange={handleAuthTypeChange}
              disabled={disableControl}>
              {authOptions?.map((obj, key) => (
                <MenuItem key={key} value={obj.value}>
                  {obj.text}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {authType === "BASIC_AUTH" && (
            <div style={{ display: "flex", gap: "4px" }}>
              <SmartPasswordField
                variant="outlined"
                size="small"
                label={t("PASSWORD")}
                value={pass || ""}
                onChange={(e) => {
                  onInputChange(
                    "PASSWORD",
                    shouldEncryptDecryptPassword
                      ? encryptString(
                        e.target.value,
                        process.env.REACT_APP_SECRET_KEY2
                      )
                      : e.target.value
                  );
                  setPass(e.target.value);
                }}
                className={"width-100"}
                name={"PASS_WORD"}
                autoComplete="off"
                disabled={disableControl}
                sx={{ input: { fontWeight: fontWeights.PASSWORD } }}
              />
              {screen && screen === "GET_DATA" && (
                <Button
                  size="small"
                  disabled={disableControl || false}
                  variant="outlined"
                  onClick={() => {
                    setValueLabel(t("PASSWORD"));
                    setWorkflowSessionModal({
                      open: true,
                      isFirstTime: true,
                    });
                  }}
                  sx={{ width: "40px", minWidth: "40px" }}>
                  <MoreHorizOutlined fontSize="small" />
                </Button>
              )}
            </div>
          )}
          {authType === t("OUTLOOK_OAUTH2") && (
            <>
              <div style={{ display: "flex", gap: "4px" }}>
                <SmartPasswordField
                  variant="outlined"
                  size="small"
                  label={t("LBL_TENANT_ID")}
                  type="text"
                  value={tenandId || ""}
                  onChange={(e) => {
                    onInputChange(e.target.name, e.target.value);
                    setTenantId(e.target.value);
                  }}
                  className={"width-100"}
                  name={"TENANT_ID"}
                  autoComplete="off"
                  disabled={disableControl}
                  sx={{ input: { fontWeight: fontWeights.TENANT_ID } }}

                />
                {screen && screen === "GET_DATA" && (
                  <Button
                    size="small"
                    disabled={disableControl || false}
                    variant="outlined"
                    onClick={() => {
                      setValueLabel(t("LBL_TENANT_ID"));
                      setWorkflowSessionModal({
                        open: true,
                        isFirstTime: true,
                      });
                    }}
                    sx={{ width: "40px", minWidth: "40px" }}>
                    <MoreHorizOutlined fontSize="small" />
                  </Button>
                )}
              </div>
              <div style={{ display: "flex", gap: "4px" }}>
                <SmartPasswordField
                  variant="outlined"
                  size="small"
                  label={t("LBL_CLIENT_ID_CONFIG")}
                  type="text"
                  value={clientId || ""}
                  onChange={(e) => {
                    onInputChange(e.target.name, e.target.value);
                    setClientId(e.target.value);
                  }}
                  className={"width-100"}
                  name={"CLIENT_ID"}
                  autoComplete="off"
                  disabled={disableControl}
                  sx={{ input: { fontWeight: fontWeights.CLIENT_ID } }}

                />
                {screen && screen === "GET_DATA" && (
                  <Button
                    size="small"
                    disabled={disableControl || false}
                    variant="outlined"
                    onClick={() => {
                      setValueLabel(t("LBL_CLIENT_ID_CONFIG"));
                      setWorkflowSessionModal({
                        open: true,
                        isFirstTime: true,
                      });
                    }}
                    sx={{ width: "40px", minWidth: "40px" }}>
                    <MoreHorizOutlined fontSize="small" />
                  </Button>
                )}
              </div>
              <div style={{ display: "flex", gap: "4px" }}>
                <SmartPasswordField
                  variant="outlined"
                  size="small"
                  label={t("LBL_CLIENT_SECRET")}
                  type="text"
                  value={clientSecret || ""}
                  onChange={(e) => {
                    onInputChange(e.target.name, e.target.value);
                    setClientSecret(e.target.value);
                  }}
                  className={"width-100"}
                  name={"CLIENT_SECRET"}
                  autoComplete="off"
                  disabled={disableControl}
                  sx={{ input: { fontWeight: fontWeights.CLIENT_SECRET } }}

                />
                {screen && screen === "GET_DATA" && (
                  <Button
                    size="small"
                    disabled={disableControl || false}
                    variant="outlined"
                    onClick={() => {
                      setValueLabel(t("LBL_CLIENT_SECRET"));
                      setWorkflowSessionModal({
                        open: true,
                        isFirstTime: true,
                      });
                    }}
                    sx={{ width: "40px", minWidth: "40px" }}>
                    <MoreHorizOutlined fontSize="small" />
                  </Button>
                )}
              </div>
            </>
          )}
          {authType === "GOOGLE_OAUTH2" && (
            <>
              <div style={{ display: "flex", gap: "4px" }}>
                <SmartPasswordField
                  variant="outlined"
                  size="small"
                  multiline
                  maxRows={4}
                  label={t("LBL_CREDENTIALS_JSON")}
                  type="text"
                  value={credentialsJson || ""}
                  onChange={(e) => {
                    onInputChange(e.target.name, e.target.value);
                    setCredentialsJson(e.target.value);
                  }}
                  className={"width-100"}
                  name={"CREDENTIALS_JSON"}
                  autoComplete="off"
                  disabled={disableControl}
                  sx={{
                    input: { fontWeight: fontWeights.CREDENTIALS_JSON },
                    textarea: {
                      fontWeight: fontWeights.CREDENTIALS_JSON,
                    },
                  }}

                />
                {screen && screen === "GET_DATA" && (
                  <Button
                    size="small"
                    disabled={disableControl || false}
                    variant="outlined"
                    onClick={() => {
                      setValueLabel(t("LBL_CREDENTIALS_JSON"));
                      setWorkflowSessionModal({
                        open: true,
                        isFirstTime: true,
                      });
                    }}
                    sx={{ width: "40px", minWidth: "40px" }}>
                    <MoreHorizOutlined fontSize="small" />
                  </Button>
                )}
              </div>

              <div style={{ display: "flex", gap: "4px" }}>
                <SmartPasswordField
                  variant="outlined"
                  size="small"
                  label={t("LBL_REFRESH_TOKEN")}
                  type="text"
                  value={refreshToken || ""}
                  onChange={(e) => {
                    onInputChange(e.target.name, e.target.value);
                    setRefreshToken(e.target.value);
                  }}
                  className={"width-100"}
                  name={"REFRESH_TOKEN"}
                  autoComplete="off"
                  disabled={disableControl}
                  sx={{
                    input: { fontWeight: fontWeights.REFRESH_TOKEN },
                  }}

                />
                {screen && screen === "GET_DATA" && (
                  <Button
                    size="small"
                    disabled={disableControl || false}
                    variant="outlined"
                    onClick={() => {
                      setValueLabel(t("LBL_REFRESH_TOKEN"));
                      setWorkflowSessionModal({
                        open: true,
                        isFirstTime: true,
                      });
                    }}
                    sx={{ width: "40px", minWidth: "40px" }}>
                    <MoreHorizOutlined fontSize="small" />
                  </Button>
                )}
              </div>
            </>
          )}
          <FormControl variant="outlined" className="width-100" size="small">
            <InputLabel id="protocolDropdownLabel">
              {t("LBL_PROTOCOL")}
            </InputLabel>
            <Select
              className={"width-100"}
              MenuProps={{
                PaperProps: {
                  sx: {
                    maxHeight: 300,
                  },
                },
              }}
              name={"MAIL_TYPE"}
              sx={{ "& .MuiSelect-select": { fontWeight: fontWeights.MAIL_TYPE } }}
              labelId="protocolDropdownLabel"
              label={t("LBL_PROTOCOL")}
              id="protocolDropdown"
              value={protocol}
              onChange={(e) => {
                onInputChange(e.target.name, e.target.value);
                setProtocol(e.target.value);
              }}
              disabled={disableControl}>
              {protocolOptions?.map((obj, key) => (
                <MenuItem key={key} value={obj.value}>
                  {t(obj.text)}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {protocol === "IMAP" && (
            <>
              <FormControl
                variant="outlined"
                className="width-100"
                size="small">
                <InputLabel id="emailTypeDropdownLabel">
                  {t("LBL_EMAIL_FOLDER")}
                </InputLabel>
                <Select
                  className={"width-100"}
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        maxHeight: 300,
                      },
                    },
                  }}
                  name={"GET_EMAIL_TYPE"}
                  sx={{ "& .MuiSelect-select": { fontWeight: fontWeights.GET_EMAIL_TYPE } }}
                  labelId="emailTypeDropdownLabel"
                  label={t("LBL_EMAIL_FOLDER")}
                  id="emailTypeDropdown"
                  value={emailType}
                  onChange={(e) => {
                    onInputChange(e.target.name, e.target.value);
                    setEmailType(e.target.value);
                  }}
                  disabled={disableControl}>
                  {emailTypeOptions?.map((obj, key) => (
                    <MenuItem key={key} value={obj.value}>
                      {t(obj.text)}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl
                variant="outlined"
                className="width-100"
                size="small">
                <InputLabel id="afterReadDropdownLabel">
                  {t("LBL_AFTER_READING")}
                </InputLabel>
                <Select
                  className={"width-100"}
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        maxHeight: 300,
                      },
                    },
                  }}
                  name={"AFTER_READ"}
                  sx={{ "& .MuiSelect-select": { fontWeight: fontWeights.AFTER_READ } }}
                  labelId="afterReadDropdownLabel"
                  label={t("LBL_AFTER_READING")}
                  id="afterReadDropdown"
                  value={afterReading}
                  onChange={(e) => {
                    onInputChange("AFTER_READ_ACTION", e.target.value);
                    setAfterReading(e.target.value);
                  }}
                  disabled={disableControl}>
                  {afterReadOptions?.map((obj, key) => (
                    <MenuItem key={key} value={obj.value}>
                      {t(obj.text)}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </>
          )}
          <FormControl variant="outlined" className="width-100" size="small">
            <InputLabel id="authTypereadData">{t("LBL_READ_DATA")}</InputLabel>
            <Select
              className={"width-100"}
              MenuProps={{
                PaperProps: {
                  sx: {
                    maxHeight: 300,
                  },
                },
              }}
              name={"READ_FROM_ATTACHMENT"}
              sx={{ "& .MuiSelect-select": { fontWeight: fontWeights.READ_FROM_ATTACHMENT } }}
              labelId="readDataDropdownLabel"
              label={t("LBL_READ_DATA")}
              id="readDataeDropdown"
              value={readData}
              onChange={(e) => {
                onInputChange(e.target.name, e.target.value);
                setReadData(e.target.value);
              }}
              disabled={disableControl}>
              {readDataOptions?.map((obj, key) => (
                <MenuItem key={key} value={obj.value}>
                  {t(obj.text)}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {readData !== "FROM_EMAIL" && (
            <>
              <div>
                <TPCheckbox
                  label={t("BTN_USE_ZIP_DECOMPRESS")}
                  checked={decompression}
                  // handleCheck={(checked) => {
                  //   if (checked) onInputChange("ZIP", "ZIP");
                  //   else onInputChange("ZIP", "");
                  //   setDecompression(checked);
                  //   if (!checked) {
                  //     onInputChange(
                  //       "SPECIFY_DECOMPRESSION_DIRECTORY",
                  //       stringifyJSONAttributes(false)
                  //     );
                  //     setShowDecompressionDir(false);
                  //     onInputChange("DECOMPRESSION_DIRECTORY", "");
                  //     setDecompressionDir("");
                  //     onInputChange(
                  //       "USE_ZIP_PASSWORD",
                  //       stringifyJSONAttributes(false)
                  //     );
                  //     setShowPassword(false);
                  //     onInputChange("ZIP_PASSWORD", "");
                  //     setPassword("");
                  //   }
                  // }}
                  handleCheck={handleDecompressionChange}
                  disabled={disableControl}
                />
              </div>
              {decompression && (
                <>
                  <div>
                    <TPCheckbox
                      label={t("LBL_SPECIFY_DECOMPRESSION_DIRECTORY")}
                      checked={showDecompressionDir}
                      handleCheck={(checked) => {
                        onInputChange(
                          "SPECIFY_DECOMPRESSION_DIRECTORY",
                          stringifyJSONAttributes(checked)
                        );
                        setShowDecompressionDir(checked);
                        if (!checked) {
                          onInputChange("DECOMPRESSION_DIRECTORY", "");
                          setDecompressionDir("");
                        }
                      }}
                      disabled={disableControl}
                    />
                  </div>
                  {showDecompressionDir && (
                    <div style={{ display: "flex", gap: "4px" }}>
                      <FormControl className="width-100" size="small">
                        <TextField
                          variant="outlined"
                          size="small"
                          label={t("LBL_DECOMPRESS_DIRECTORY")}
                          type="text"
                          value={decompressionDir || ""}
                          onChange={(e) => {
                            onInputChange(e.target.name, e.target.value);
                            setDecompressionDir(e.target.value);
                          }}
                          className={"width-100"}
                          name={"DECOMPRESSION_DIRECTORY"}
                          autoComplete="off"
                          disabled={disableControl}
                          sx={{
                            input: {
                              fontWeight: fontWeights.DECOMPRESSION_DIRECTORY,
                            },
                          }}
                        />
                      </FormControl>
                      {screen && screen === "GET_DATA" && (
                        <Button
                          size="small"
                          disabled={disableControl || false}
                          variant="outlined"
                          onClick={() => {
                            setValueLabel(t("LBL_DECOMPRESS_DIRECTORY"));
                            setWorkflowSessionModal({
                              open: true,
                              isFirstTime: true,
                            });
                          }}
                          sx={{ width: "40px", minWidth: "40px" }}>
                          <MoreHorizOutlined fontSize="small" />
                        </Button>
                      )}
                    </div>
                  )}
                  <div>
                    <TPCheckbox
                      label={t("LBL_WS_PASSWORD")}
                      checked={showPassword}
                      handleCheck={(checked) => {
                        onInputChange(
                          "USE_ZIP_PASSWORD",
                          stringifyJSONAttributes(checked)
                        );
                        setShowPassword(checked);
                        if (!checked) {
                          setPassword("");
                          onInputChange("ZIP_PASSWORD", "");
                        }
                      }}
                      disabled={disableControl}
                    />
                  </div>
                  {showPassword && (
                    <div style={{ display: "flex", gap: "4px" }}>
                      <SmartPasswordField
                        variant="outlined"
                        size="small"
                        label={t("PASSWORD_")}
                        value={password || ""}
                        onChange={(e) => {
                          onInputChange(
                            e.target.name,
                            encryptString(
                              e.target.value,
                              process.env.REACT_APP_SECRET_KEY2
                            )
                          );
                          setPassword(e.target.value);
                        }}
                        className={"width-100"}
                        name={"ZIP_PASSWORD"}
                        autoComplete="off"
                        disabled={disableControl}
                        sx={{ input: { fontWeight: fontWeights.ZIP_PASSWORD } }}
                      />
                      {screen && screen === "GET_DATA" && (
                        <Button
                          size="small"
                          disabled={disableControl || false}
                          variant="outlined"
                          onClick={() => {
                            setValueLabel(t("PASSWORD_"));
                            setWorkflowSessionModal({
                              open: true,
                              isFirstTime: true,
                            });
                          }}
                          sx={{ width: "40px", minWidth: "40px" }}>
                          <MoreHorizOutlined fontSize="small" />
                        </Button>
                      )}
                    </div>
                  )}
                </>
              )}
            </>
          )}
        </>
      )}
      <WorkflowSessionModal
        valueLabel={valueLabel}
        showAccountData={true}
        showCallingWorkflow={true}
        showSystemData={true}
        showWorkflowSession={true}
        showDateAndTime={true}
        openModal={workflowSessionModal}
        setModalOpen={setWorkflowSessionModal}
        handleClose={() =>
          setWorkflowSessionModal({ open: false, isFirstTime: false })
        }
        initialValue={workflowMappings[valueLabel]?.value}
        valuesHandler={(value) => {
          valuesHandler(value);
        }}
        inputType={workflowMappings[valueLabel]?.inputType}
        specialPasswordField={workflowMappings[valueLabel]?.specialPasswordField}
        initialMaskLength={getCurrentMaskLength(valueLabel)}
      />
      <Drawer
        anchor="left"
        open={openModal}
        onClose={() => setOpenModal(false)}
        ModalProps={{
          onClose: handleBackdropClick,
        }}
        SlideProps={{
          style: {
            transform: openModal ? "translateX(0)" : "translateX(-240px)",
          },
        }}
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
            boxShadow: "none",
          },
        }}>
        <div style={{ borderRight: "solid 1px #e0e0e0", height: "100%" }}>
          <div
            className="flex-column height-100"
            style={{ backgroundColor: "#fff", position: "relative" }}>
            <div className="quick-add-container padding-16 flex">
              <div style={{ lineHeight: "25px" }}>
                <p style={{ marginBottom: "10px" }}>
                  {t("DIAG_EMAIL_BODY_TIT")}
                </p>
                <div className="font-12">
                  <p>{t("DIAG_EMAIL_BODY_DESC")}</p>
                </div>
              </div>
              <Button
                size="small"
                style={{ background: "white" }}
                onClick={() => handleCancel()}>
                <CloseIcon fontSize="large" />
              </Button>
            </div>
            <hr />
            <div style={{ lineHeight: "25px" }} className="padding-16">
              <TextField
                multiline
                rows={4}
                variant="outlined"
                size="small"
                type="text"
                value={bodyContent || ""}
                onChange={(e) => {
                  // onInputChange(e.target.name, e.target.value);
                  setBodyContent(e.target.value);
                }}
                className={"width-100"}
                name={"BODY"}
                autoComplete="off"
              />
            </div>
            <div className="margin-top-4 margin-left-16">
              <TPCheckbox
                label={t("BTN_USE_HTML_TO_FORMAT_EMAIL_BODY")}
                checked={asHtml}
                handleCheck={(checked) => {
                  // onInputChange(
                  //   "HTML_CONTENT",
                  //   stringifyJSONAttributes(checked)
                  // );
                  setAsHtml(checked);
                }}
              />
              <Button
                size="small"
                style={{ marginLeft: "65px" }}
                variant="outlined"
                color="primary"
                onClick={() => handleDone(bodyContent, asHtml)}>
                {t("BTN_DONE")}
              </Button>
            </div>
          </div>
        </div>
      </Drawer>
      <Snackbar open={showAlert.isOpen} onClose={() => handleAlertClose()}>
        <Alert
          onClose={() => handleAlertClose()}
          severity={showAlert.type}
          variant="filled"
          sx={{ width: "100%" }}>
          {showAlert.mssg}
        </Alert>
      </Snackbar>
    </>
  );
};

export default Email;
